export const cuisineData = {
  cuisineRegion: {
    "Latin American": [
      "Peruvian",
      "Mexican",
      "Brazilian",
      "Colombian",
      "Cuban",
      "Other",
    ],
    Caribbean: ["Jamaican", "Haitian", "Dominican", "Other"],
    "North American": [
      "Southern American",
      "Tex-Mex",
      "Cajun",
      "American",
      "Canadian",
      "Other",
    ],
    "Middle Eastern": ["Turkish", "Lebanese", "Persian", "Other"],
    "East Asian": ["Chinese", "Japanese", "Korean", "Other"],
    "Southeast Asian": ["Thai", "Vietnamese", "Filipino", "Other"],
    "South Asian": ["Nepali", "Indian", "Pakistani", "Other"],
    European: ["Italian", "French", "Spanish", "German", "Greek", "Other"],
    African: [
      "Ethiopian",
      "Nigerian",
      "Moroccan",
      "Ghanian",
      "Egyptian",
      "Other",
    ],
    "Hawaiian / Pacific Islands": ["Hawaiian", "Fijian", "Other"],
  },
  proteinChoice: [
    "Plant-Based",
    "Chicken",
    "Fish",
    "Shellfish",
    "Beef",
    "Pork",
    "Lamb",
    "Egg",
    "Other animal based",
  ],
  dietaryRestriction: [
    "Vegan",
    "Vegetarian",
    "Pescatarian",
    "Nut-Free",
    "Gluten-Free",
    "Dairy-Free",
    "Shellfish-Free",
    "Paleo",
    "Keto",
    "Low-Carb",
  ],
  religiousRestriction: [
    "Halal",
    "Kosher",
    "Kosher Parve",
    "Hindu (Satvik)",
    /*  
    "Ahimsa (Buddhist)*",
    "Ahimsa (Jain)*",
    "Jhatka*",
    "Lenten?*",
    */
  ],
};
